module.exports = __webpack_public_path__ + "media/images/order/done_schedule-65c18dd4e8ba946ed3c645b06c4864af.jpg";